// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cancelModalHeading {
    font-weight: 700;
    color: var(--surface-g5);
    font-size: 1.25rem;
    text-align: center;
    line-height: 100%;
}

.cancelModalActionButtons{
    display: flex;
    gap: 8px;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/CancelAndConfirmModal/CancelAndConfirmModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB","sourcesContent":[".cancelModalHeading {\n    font-weight: 700;\n    color: var(--surface-g5);\n    font-size: 1.25rem;\n    text-align: center;\n    line-height: 100%;\n}\n\n.cancelModalActionButtons{\n    display: flex;\n    gap: 8px;\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
